import * as React from 'react';

type HowToPlayProps = {
    onClose: () => void;
}

export function HowToPlay(props: HowToPlayProps) {
    return (
        <div className='how-to-play'>
            <div>
                <header>How to Play Waterfall Poker</header>
                Overview:
                <ul>
                    <li>Match cards in the bottom row to a poker hand by strategically discarding cards.</li>
                    <li>After discarding or playing a hand, the cards above fall down into the empty places.</li>
                </ul>
                Rules:
                <ul>
                    <li>You may only play a hand if you have a valid poker hand.</li>
                    <li>You may discard cards in the bottom row by clicking on them.</li>
                    <li>Discards are placed on the bottom of the deck to be played again.</li>
                    <li>When a card is removed another card from the deck is added to the column with the fewest number of cards.</li>
                    <li>The game ends when you can't play a hand and have no more discards left.</li>
                </ul>
                Scoring:
                <ul>
                    <li>One pair: 2 points</li>
                    <li>Two pair: 5 points</li>
                    <li>Three of a kind: 10 points</li>
                    <li>Straight: 15 points</li>
                    <li>Flush: 20 points</li>
                    <li>Full house: 25 points</li>
                    <li>Four of a kind: 50 points</li>
                    <li>Straight flush: 75 points</li>
                    <li>Royal flush: 100 points</li>
                    <li>Clear all cards: 100 bonus points</li>
                </ul>
                Tips:
                <ul>
                    <li>Try to use all of your discards to move cards into place for your next hand.</li>
                </ul>
                Keyboard shortcuts:
                <ul>
                    <li>Enter - Play hand</li>
                    <li>1 to 5 - Discard card 1 to 5 (left to right)</li>
                </ul>
            </div>
            <button onClick={() => props.onClose()}>X Close</button>
        </div>
    );
}
